// Close codes for the realtime WebSocket between the coordinator DO and its
// clients (the editor / agent-cli via bedrock-sdk) and the sandbox supervisor.
// Single source of truth: both ends key their handshake on these exact codes,
// so any new code or rename must land here, not as a bare literal at a call site.

// Normal closure. Used to tear down a relayed leg after the other side dropped
// with an abnormal code (e.g. 1006) that WebSocket.close() refuses to forward.
export const WS_CLOSE_NORMAL = 1000;

// (Andrew, 2026-07-02, REPL-28713): RFC 6455 "going away" — sent by the bridge on
// shutdown signals so the coordinator can tell shutdown from transport death (1006).
export const WS_CLOSE_GOING_AWAY = 1001;

// RFC 6455 reserved code reported when the peer vanishes without a Close frame — never sent on the wire.
export const WS_CLOSE_ABNORMAL = 1006;

// Tells the client its token is the problem — force-refresh and reconnect.
export const WS_CLOSE_AUTH_FAILED = 4001;

// (Andrew, 2026-07-01, REPL-28688): Valid token, but its user is not the routed
// actor — a refreshed token has the same sub, so clients must not retry.
export const WS_CLOSE_IDENTITY_MISMATCH = 4002;

// Connection requested a sandbox override (dev alias / custom image) that the
// authenticated user is not allowed to use.
export const WS_CLOSE_FORBIDDEN = 4003;

// No bound sandbox, or the supervisor's sandbox is stale: it should exit.
export const WS_CLOSE_SESSION_NOT_FOUND = 4004;

// (Andrew, 2026-07-01, REPL-28678): Client heartbeat watchdog gave up on an unresponsive link; genuine transport death still logs 1006.
export const WS_CLOSE_HEARTBEAT_TIMEOUT = 4008;

// A newer connection replaced this one (same framework connection id).
export const WS_CLOSE_DUPLICATE_CONNECTION = 4009;

// (Andrew, 2026-07-06, REPL-28639): Browser client leaving the page (pagehide) — browsers forbid script-sent 1001, so deliberate departures get this instead of dying as 1006.
export const WS_CLOSE_PAGE_HIDDEN = 4010;

// Auth upstream (publisher hydrate) is unavailable; the client may retry.
export const WS_CLOSE_UPSTREAM_UNAVAILABLE = 1013;
